import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    skin: PropTypes.oneOf([
        'simple',
        'comparison',
        'dividers'
    ])
};
const Table = createComponent({
    displayName: 'Table',
    root: 'table',
    propTypes,
    propConfig: {
        classNames (props) {
            return [
                `swan-table-skin-${props.skin}`
            ];
        }
    }
});
Table.defaultProps = {
    skin: 'simple'
};

export { Table };
